import { convertToHumanReadableDate } from '@shared/utils/date-utils';
import { useTranslation } from 'react-i18next';
import editableTemplateStyles from '@modules/proposals/presentation/v2/pages/ProposalCreation/es/views/EditableTemplate/styles';
import { Flex, Text } from '@huspy/briks-web';

type Props = {
  clientName: string;
  brokerName: string;
  brokerLogo: string;
  brokerEmail?: string;
  brokerPhone?: string;
};

export const Header = ({
  brokerName,
  clientName,
  brokerLogo,
  brokerEmail,
  brokerPhone,
}: Props) => {
  const { t } = useTranslation();
  return (
    <Flex pr='10' pt='10'>
      <Flex direction='column' pl='10' pr='10' gap='1'>
        <Text fontSize='6xl' fontWeight='semibold' letterSpacing='-2px'>
          {t('proposals.template.header.title')}
        </Text>
        <Text color='neutral.700'>
          {t('proposals.template.header.preparedFor', {
            clientName: clientName.trim(),
            brokerName: brokerName.trim(),
          })}
        </Text>
        <Text color='neutral.700'>
          {convertToHumanReadableDate(new Date())}
        </Text>
        <Text color='neutral.700'>{brokerEmail}</Text>
        <Text color='neutral.700'>{brokerPhone}</Text>
      </Flex>
      <img
        src={ brokerLogo }
        className={ editableTemplateStyles.image }
        height='20px'
        alt='Bayteca Logo'
      />
    </Flex>
  );
};
